export default "__VITE_ASSET__BJ50C1Cm__"